import {captureExceptionWithLevel} from '@zzng/common/utils/matrix';

export const preloadImage = (url: string) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      // decode()를 시도하고 실패하면 일반 방식으로 폴백
      if (typeof img.decode === 'function') {
        img
          .decode()
          .then(() => resolve(img))
          .catch((error) => {
            captureExceptionWithLevel(`이미지 decode 실패: ${img.src}\n\n${JSON.stringify(error)}`, 'warning');
            resolve(img);
          });
      } else {
        resolve(img);
      }
    };
    img.onerror = reject;
    img.src = url;
  });
};
